import styled from "styled-components";

import { color } from "style/constants";

export const NotificationBody = styled.p`
  color: ${color.DARKERGRAY};
  font-weight: 300;
`;

export const NotificationCard = styled.div`
  p {
    margin: 0;
  }
`;

export const NotificationTitle = styled.p`
  color: ${color.BLACK};
`;
